import { Injectable } from '@angular/core';
import { MedicalFeeService } from 'src/app/services/medical-fee/medical-fee.service';
import { MedicalFeePaymentManualService } from './medical-fee-payment-manual.service';
import { MedicalFeePaymentEditInfo } from '../../model/medical-fee/medical-fee-payment-edit-info';
import { MedicalFeeAmount } from '../../model/medical-fee/medical-fee-amount';
import { MedicalFeeAmountService } from './medical-fee-amount.service';

@Injectable()
export class MedicalFeePaymentManualWizardService {

  constructor( private mfpService: MedicalFeePaymentManualService,
               private mfaService: MedicalFeeAmountService,
               private mfService: MedicalFeeService) { }

  medicalFeePaymentEditInfo: MedicalFeePaymentEditInfo;

  async init() {
    this.medicalFeePaymentEditInfo =
      await this.mfpService.getMedicalFeePaymentEditInfo();
  }

  getMedicalFeeAmount() {
    return this.medicalFeePaymentEditInfo.MedicalFeeAmount;
  }

  getPhysicianId() {

    if ( this.medicalFeePaymentEditInfo.MedicalFeeAmount.Physician ) {
      return this.medicalFeePaymentEditInfo.MedicalFeeAmount.Physician.Id;
    }
    return null;
  }

  async recalculate( ) {
    this.setMedicalFeeAmount(await this.mfaService
      .recalculateMedicaFeeAmounts(this.getMedicalFeeAmount()));
  }

  setMedicalFeeAmount( medicalFeeAmount: MedicalFeeAmount ) {
    this.medicalFeePaymentEditInfo.MedicalFeeAmount = medicalFeeAmount;
  }

  async createReport() {
    return await this.mfService.createMedicalFeeReport( this.medicalFeePaymentEditInfo );
  }

  async createMedicalFeeBill() {
    await this.mfpService.createMedicalFeeBill( this.medicalFeePaymentEditInfo );
  }
}
